import { render, staticRenderFns } from "./bingDialog.vue?vue&type=template&id=138e2622&scoped=true&"
import script from "./bingDialog.vue?vue&type=script&lang=js&"
export * from "./bingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e2622",
  null
  
)

export default component.exports